import React from 'react';
import { Href, Link, usePathname } from 'expo-router';

import CenterInFull from './center-in-full';

function PossiblyCenter({ children }: { children: React.ReactNode }) {
  return <CenterInFull>{children}</CenterInFull>;
}

const FooterLink = ({
  href,
  children,
  newPage = false,
}: {
  href: Href;
  children: React.ReactNode;
  newPage?: boolean;
}) => (
  <Link
    href={href}
    target={newPage ? '_blank' : '_self'}
    className="underline underline-offset-2 text-subtle-600 text-xs hover:text-subtle-500 transition-colors"
  >
    {children}
  </Link>
);

const Divider = () => <span className="text-subtle-600">|</span>;

const FooterContent = ({ children }: { children: React.ReactNode }) => (
  <footer className="mt-2 py-4 sm:py-6 px-6 border-t border-border min-h-[50px] flex justify-end">
    <div className="flex flex-col sm:flex-row items-end sm:items-center gap-2 sm:gap-4">
      <p className="text-subtle-600 gap-2 flex flex-wrap justify-center items-center text-xs">
        {children}
      </p>
    </div>
  </footer>
);

export default function CustomFooter() {
  const pathname = usePathname();
  const isDemos = [
    '/demos',
    '/profile',
    '/manage-subscription',
    '/privacy',
    '/terms',
  ].some((path) => pathname?.endsWith(path) || pathname?.endsWith(path + '/'));

  return (
    <PossiblyCenter>
      <FooterContent>
        {isDemos ? (
          <>
            <FooterLink href="/docs/terms">Terms</FooterLink>
            <Divider />
            <FooterLink href="/docs/privacy">Privacy Policy</FooterLink>
          </>
        ) : (
          <>
            Follow me on{' '}
            <FooterLink href="https://x.com/reactiive_" newPage>
              Twitter
            </FooterLink>
            <span className="text-subtle-600 hidden sm:inline">|</span>
            <FooterLink href="/inspirations">Inspirations</FooterLink>
          </>
        )}
      </FooterContent>
    </PossiblyCenter>
  );
}
